import { useNavigate } from "react-router-dom";
import styles from "../../screens/Requirement/Requirement.module.css";
import { PiFileTextThin } from "react-icons/pi";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import {
  Box,
  Checkbox,
  Grid,
  Slider,
  Typography,
  TextField,
  MenuItem,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import {
  getPostRequirement,
  UpdateAction,
} from "../../redux/post-requirement/postRequirementSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatDate, formatTime } from "../../utils/const";

const MatchesResultPublicResume = ({
  name,
  mode,
  client,
  rate,
  salary,
  skills,
  btn1,
  btn2,
  requirement,
  date,
  handleShow,
  setHotListRow,
  handleShowPostRequirementRepublish,
  handleShowShowMatching,
}) => {
  const [open, setOpen] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [actionName, setActionName] = useState(requirement?.job_status);
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const postRequirementStatus = useSelector(
    (state) => state.postrequirement.candidateStatus
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenAction = () => {
    setOpenAction(true);
  };

  const handleCloseAction = () => {
    setOpenAction(false);
  };

  const handleOnChangeAction = (name) => {
    setActionName(name);
    handleOpen();
  };

  const handleOnClickRePublish = (name) => {
    setActionName(name);
    setHotListRow(requirement);
    handleShowPostRequirementRepublish();
    handleCloseAction();
  };

  const handleOnClickReMatching = (name) => {
    setActionName(name);
    setHotListRow(requirement);
    handleShowShowMatching();
    handleCloseAction();
  };

  const theme = useTheme();
  const contentRef = useRef(null);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleOnClickChangeAction = () => {
    let updatedValues = {
      job_status: actionName,
    };
    let jobId = requirement?.job_id;
    dispatch(UpdateAction({ updatedValues, jobId }));
  };

  useEffect(() => {
    if (postRequirementStatus === "update_action") {
      dispatch(getPostRequirement());
      handleClose();
      handleCloseAction();
    }
  }, [postRequirementStatus]);

  return (
    <Box className={styles.matches_resume_result}>
      <Box sx={{ backgroundColor: "#fff !important" }}>
        <span>
          <Typography>
            Job Title:{" "}
            <b
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => {
                setHotListRow(requirement);
                handleShow();
                localStorage.setItem(
                  "postJobDetails",
                  JSON.stringify({ row: requirement })
                );
              }}
            >
              {name}
            </b>
            , <b>Exp {requirement?.experience}</b>
          </Typography>
          <Typography>
            Mode of Hiring: <b>{mode}</b>
          </Typography>
          <Typography>
            Location: <b>{client}</b>
          </Typography>
          <Typography>
            {requirement?.requirement_type?.includes("full_Time")
              ? "Salary"
              : "Rate"}{" "}
            :{" "}
            <b>
              ${salary}
              {salary > 0
                ? requirement?.requirement_type?.includes("full_Time")
                  ? "K Yearly"
                  : " Hourly"
                : "Non Disclosed"}{" "}
            </b>
          </Typography>

          <Typography>
            Mandatory skills:{" "}
            <b
              style={{
                overflow: "hidden",
                transition: "height 0.1s ease",
                height: showMore
                  ? `${contentRef.current?.scrollHeight}px`
                  : `${contentRef.current?.firstChild?.offsetHeight}px`,
              }}
            >
              <b ref={contentRef}>
                {showMore
                  ? skills // Show full text
                  : skills !== undefined &&
                    skills !== "" &&
                    skills !== null &&
                    `${skills?.slice(0, 50)}`}{" "}
                <a
                  onClick={() => setShowMore(!showMore)}
                  style={{
                    textDecoration: "underline",
                    color: "#4b8ae9",
                    paddingLeft: "15px",
                    fontSize: "13px",
                    cursor: "pointer",
                  }}
                >
                  {skills?.length > 20 &&
                    (showMore ? "View Less" : "View More")}
                </a>
              </b>
            </b>
          </Typography>
        </span>

        <span style={{ alignSelf: "flex-end" }}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 10px 0 40px",
            }}
          >
            <Typography>{`${formatDate(date)}, ${formatTime(
              date
            )}`}</Typography>
          </span>
          <div
            style={{
              marginTop: "35px",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <button
              style={{ padding: "7.5px 1px" }}
              onClick={() => {
                setHotListRow(requirement);
                handleShow();
                localStorage.setItem(
                  "postJobDetails",
                  JSON.stringify({ row: requirement })
                );
              }}
            >
              {btn1}
            </button>
            <button style={{ marginLeft: "10px" }} onClick={handleOpenAction}>
              {btn2}
            </button>
          </div>
        </span>
      </Box>
      <Dialog
        fullScreen={fullScreen}
        open={openAction}
        onClose={handleCloseAction}
        maxWidth="sm"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogContent
            sx={{
              display: "flex",
              justifyContent: "start",
              flexDirection: "column",
            }}
          >
            {/* <Box>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                  value="Active"
                  checked={actionName === "Active"}
                  onChange={() => handleOnChangeAction("Active")}
                />
                <label class="form-check-label" htmlFor="exampleRadios1">
                  Open
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios2"
                  value="On Hold"
                  checked={actionName === "On Hold"}
                  onChange={() => handleOnChangeAction("On Hold")}
                />
                <label class="form-check-label" htmlFor="exampleRadios2">
                  Hold
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios3"
                  value="Closed"
                  checked={actionName === "Closed"}
                  onChange={() => handleOnChangeAction("Closed")}
                />
                <label class="form-check-label" htmlFor="exampleRadios3">
                  Close
                </label>
              </div>
            </Box> */}
            <span>
              <b>What's in your mind?</b>
            </span>
            <Typography>You can change job status at any time.</Typography>
          </DialogContent>

          <Grid container sx={{ marginBottom: "15px" }}>
            <Grid
              item
              sm={12}
              md={2}
              lg={2}
              className={styles.actionCard}
              sx={
                actionName === "Active"
                  ? {
                      backgroundColor: "#2d73b5",
                      color: "#fff",
                      marginLeft: "18px !important",
                    }
                  : { marginLeft: "18px !important" }
              }
              onClick={() => handleOnChangeAction("Active")}
            >
              <span>Open</span>
            </Grid>
            <Grid
              item
              sm={12}
              md={2}
              lg={2}
              className={styles.actionCard}
              sx={
                actionName === "On Hold"
                  ? { backgroundColor: "#2d73b5", color: "#fff" }
                  : {}
              }
              onClick={() => handleOnChangeAction("On Hold")}
            >
              <span>Hold</span>
            </Grid>
            <Grid
              item
              sm={12}
              md={2}
              lg={2}
              className={styles.actionCard}
              sx={
                actionName === "Closed"
                  ? { backgroundColor: "#2d73b5", color: "#fff" }
                  : {}
              }
              onClick={() => handleOnChangeAction("Closed")}
            >
              <span>Close</span>
            </Grid>
            <Grid
              item
              sm={12}
              md={2}
              lg={2}
              className={styles.actionCard}
              sx={
                actionName === "Republish"
                  ? { backgroundColor: "#2d73b5", color: "#fff" }
                  : {}
              }
              onClick={() => handleOnClickRePublish("Republish")}
            >
              <span>Republish</span>
            </Grid>
            <Grid
              item
              sm={12}
              md={2}
              lg={2}
              className={styles.actionCard}
              sx={
                actionName === "Re-Matching"
                  ? { backgroundColor: "#2d73b5", color: "#fff" }
                  : {}
              }
              onClick={() => handleOnClickReMatching("Re-Matching")}
            >
              <span>Re-Matching</span>
            </Grid>
          </Grid>

          {/* <Box>
            <Box className={styles.adding_internal_btns}>
              <button sx={{ backgroundColor: "#2d73b5" }} onClick={handleOpen}>
                Change
              </button>
              <button
                sx={{ backgroundColor: "#97B6F1" }}
                onClick={handleCloseAction}
              >
                Cancel
              </button>
            </Box>
          </Box> */}
        </Box>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        maxWidth="sm"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center" }}
          >
            <b>Job Action Change</b>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            Are you sure you want to change action to {actionName}
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                onClick={handleOnClickChangeAction}
              >
                Yes
              </button>
              <button sx={{ backgroundColor: "#97B6F1" }} onClick={handleClose}>
                No
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default MatchesResultPublicResume;
